// src/index.js
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import { detectSourceFromHostname, applyBrandToDOM } from "./utils/branding";
import { isTrackingHost } from "./pages/public-tracking/trackingHost";

// Public tracking never mounts merchant authentication or merchant routes.
const TrackingApp = lazy(() => import("./pages/public-tracking/TrackingApp"));
const MerchantRoot = lazy(() => import("./MerchantRoot"));
const trackingOnly =
  isTrackingHost(window.location.hostname) ||
  (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_TRACKING_PREVIEW === "true");

const detectedSource = detectSourceFromHostname(window.location.hostname);
applyBrandToDOM(detectedSource);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      {trackingOnly ? <TrackingApp /> : <MerchantRoot />}
    </Suspense>
  </React.StrictMode>,
);
